module.exports = __webpack_public_path__ + "img/xs-logo-flat.4e6d1799.png";